var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"cell_content"},[_c('li',{staticClass:"cell_item"},[_c('span',{staticClass:"cell_label"},[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_c('span',{staticClass:"cell_value"},[_vm._v(_vm._s(_vm.value)+" ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-007e11a8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/cell.vue
// module id = null
// module chunks = 